import { Badge, type BadgeProps } from "@/components/ui/badge"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Progress } from "@/components/ui/progress"
import { cn } from "@/lib/utils"
import type { CourseStatus } from "@/services/api/cronos/tracking/students/get-situation"
import { getProgressStatus } from "../../helpers/get-progress-status"

interface CoursesProgressProps {
  courseProgress: number
  courseStatus: CourseStatus | null
}

export default function CoursesProgress({ courseProgress, courseStatus }: CoursesProgressProps) {
  const progressStatus = courseStatus ? getProgressStatus(courseStatus) : null

  return (
    <Card className="flex min-h-[174px] min-w-[475px] flex-1 flex-col border-none">
      <CardHeader>
        <CardTitle className="text-sm font-semibold text-foreground">
          Progreso de la materia
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-1 flex-col gap-4">
        <section className="flex items-center justify-between">
          <article className="flex items-center gap-2">
            <h2 className="text-large-title-emphasized font-bold text-foreground">
              {courseProgress}%
            </h2>
            {progressStatus && (
              <Badge
                variant={progressStatus.variant as BadgeProps["variant"]}
                className={cn(
                  "gap-2 py-1 font-medium text-foreground",
                  progressStatus.variant === "default" && "bg-green-100",
                  progressStatus.variant === "warning" && "bg-yellow-100",
                  progressStatus.variant === "destructive" && "bg-red-100",
                )}
              >
                <img className="h-3 w-3" src={progressStatus.image} alt={progressStatus.label} />
                <span className="text-xs">{progressStatus.label}</span>
              </Badge>
            )}
          </article>
          {progressStatus && (
            <span className="text-xs text-muted-foreground">{progressStatus.description}</span>
          )}
        </section>
        <Progress value={courseProgress} className="h-3" />
      </CardContent>
    </Card>
  )
}
